import {api} from 'lib/url'
import {useRoom} from 'organization/Event/Room/RoomProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {useQuery} from 'react-query'
import {useQueryClient} from 'react-query'

export type StreamSettings = {
  stream_url: string
  stream_key: string
  stream_page_url: string
}

export function useStreamSettings() {
  const {room} = useRoom()

  const {client} = useOrganization()

  return useQuery({
    queryKey: ['rooms', room.id, 'stream-settings'],
    queryFn: () =>
      client.get<StreamSettings>(api(`/rooms/${room.id}/stream-settings`)),
  })
}

export function useUpdateStreamSettings() {
  const {room} = useRoom()
  const {client} = useOrganization()
  const qc = useQueryClient()

  return async (settings: StreamSettings) => {
    await client.post(api(`/rooms/${room.id}/stream-settings`), settings)
    qc.invalidateQueries(['rooms', room.id, 'stream-settings'])
  }
}
